export default __webpack_public_path__ + "static/media/tilicho.71cdf3fe.jpeg";